﻿(function () {
  function qs(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function qsa(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function show(el) {
    if (el) el.removeAttribute("hidden");
  }

  function formatMoney(cents, currency) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency || "USD"
      }).format(amount);
    } catch (e) {
      return "$" + amount.toFixed(2);
    }
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function renderCartBody(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return "<p>Your cart is empty.</p>";
    }

    var html = ["<ul class='cart-drawer-items'>"];
    cart.items.forEach(function (item) {
      html.push(
        "<li class='cart-drawer-item'>" +
          "<a href='" +
          item.url +
          "' class='cart-drawer-item__title'>" +
          escapeHtml(item.product_title) +
          "</a>" +
          "<div class='cart-drawer-item__meta'>Qty " +
          item.quantity +
          "</div>" +
          "<div class='cart-drawer-item__price'>" +
          formatMoney(item.final_line_price, cart.currency) +
          "</div>" +
          "</li>"
      );
    });
    html.push("</ul>");
    return html.join("");
  }

  function updateCartDrawer(cart) {
    var body = qs("[data-cart-body]");
    var footer = qs("[data-cart-footer]");
    if (!body || !footer) return;

    body.innerHTML = renderCartBody(cart);

    var subtotal = formatMoney(cart.total_price, cart.currency);
    footer.innerHTML =
      "<div class='cart-drawer-subtotal'><strong>Subtotal:</strong> " +
      subtotal +
      "</div>" +
      "<a class='btn-primary' href='/cart'>Open cart</a>" +
      "<button class='btn-primary' type='button' data-cart-checkout>Checkout</button>";
  }

  function fetchCart() {
    return fetch("/cart.js").then(function (r) {
      return r.json();
    });
  }

  function openCartDrawer() {
    show(qs("#CartDrawer"));
  }

  function sendAddToCart(formData) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok) throw json;
        return json;
      });
    });
  }

  function setSubmitting(button, state, label) {
    if (!button) return;
    button.disabled = state;
    if (state && label) {
      button.dataset.originalLabel = button.textContent;
      button.textContent = label;
    } else if (!state && button.dataset.originalLabel) {
      button.textContent = button.dataset.originalLabel;
    }
  }

  document.addEventListener("submit", function (e) {
    var productForm = e.target.closest("form[data-type='add-to-cart-form']");
    var stickyForm = e.target.closest("form[data-sticky-atc-form]");
    var targetForm = productForm || stickyForm;
    if (!targetForm) return;

    e.preventDefault();

    var submitBtn = targetForm.querySelector("button[type='submit']");
    setSubmitting(submitBtn, true, "Adding...");

    var formData = new FormData(targetForm);

    sendAddToCart(formData)
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        updateCartDrawer(cart);
        openCartDrawer();
        document.dispatchEvent(new CustomEvent("endmarket:cart-updated", { detail: cart }));
      })
      .catch(function () {
        if (submitBtn) submitBtn.textContent = "Try again";
      })
      .finally(function () {
        setSubmitting(submitBtn, false);
      });
  });

  document.addEventListener("click", function (e) {
    var openCart = e.target.closest("[data-open-cart]");
    var checkout = e.target.closest("[data-cart-checkout]");

    if (checkout) {
      window.location.href = "/checkout";
      return;
    }

    if (!openCart) return;
    e.preventDefault();

    fetchCart()
      .then(function (cart) {
        updateCartDrawer(cart);
        openCartDrawer();
      })
      .catch(function () {
        openCartDrawer();
      });
  });

  qsa("[data-product-section]").forEach(function (section) {
    var currency = section.getAttribute("data-currency") || "USD";
    var variantSelect = qs("[data-variant-select]", section);
    var addBtn = qs("[data-add-to-cart-btn]", section);
    var sticky = qs("[data-sticky-atc]", section);
    var stickyVariantInput = qs("[data-sticky-variant-id]", section);
    var stickyPrice = qs("[data-sticky-price]", section);
    var stickyBtn = qs("[data-sticky-add-btn]", section);
    var mainMedia = qs("[data-main-media]", section);

    function syncVariantState() {
      if (!variantSelect || variantSelect.tagName !== "SELECT") return;
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (!opt) return;

      var available = opt.getAttribute("data-available") === "true";
      var price = Number(opt.getAttribute("data-price") || 0);
      var comparePrice = Number(opt.getAttribute("data-compare-at-price") || 0);
      var mediaId = opt.getAttribute("data-featured-media-id");

      var priceHtml =
        comparePrice > price
          ? "<div class='price-block'><span class='price price--sale'>" +
            formatMoney(price, currency) +
            "</span><s class='price price--compare'>" +
            formatMoney(comparePrice, currency) +
            "</s></div>"
          : "<div class='price-block'><span class='price'>" + formatMoney(price, currency) + "</span></div>";

      var priceWrap = qs("[data-price-wrapper]", section);
      if (priceWrap) priceWrap.innerHTML = priceHtml;
      if (stickyPrice) stickyPrice.textContent = formatMoney(price, currency);

      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? "Add to cart" : "Sold out";
      }
      if (stickyBtn) stickyBtn.disabled = !available;
      if (stickyVariantInput) stickyVariantInput.value = opt.value;

      if (mediaId && mainMedia) {
        var thumb = qs("[data-media-thumb][data-media-id='" + mediaId + "']", section);
        if (thumb) {
          var nextSrc = thumb.getAttribute("data-media-src");
          var nextAlt = thumb.getAttribute("data-media-alt") || "";
          mainMedia.src = nextSrc;
          mainMedia.alt = nextAlt;
          qsa("[data-media-thumb]", section).forEach(function (b) {
            b.classList.remove("is-active");
          });
          thumb.classList.add("is-active");
        }
      }
    }

    if (variantSelect && variantSelect.tagName === "SELECT") {
      variantSelect.addEventListener("change", syncVariantState);
      syncVariantState();
    }

    qsa("[data-media-thumb]", section).forEach(function (thumbBtn) {
      thumbBtn.addEventListener("click", function () {
        if (!mainMedia) return;
        mainMedia.src = thumbBtn.getAttribute("data-media-src");
        mainMedia.alt = thumbBtn.getAttribute("data-media-alt") || "";
        qsa("[data-media-thumb]", section).forEach(function (b) {
          b.classList.remove("is-active");
        });
        thumbBtn.classList.add("is-active");
      });
    });

    if (sticky && addBtn && "IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              sticky.setAttribute("hidden", "");
            } else {
              sticky.removeAttribute("hidden");
            }
          });
        },
        { threshold: 0.2 }
      );
      observer.observe(addBtn);
    }
  });
})();
